export default {
  SET_DELETE_MODAL_OPEN: 'TEACHER_ACTIVITY/SET_DELETE_MODAL_OPEN',
  DELETE_ACTIVITY_REQUEST: 'TEACHER_ACTIVITY/DELETE_ACTIVITY_REQUEST',
  DELETE_ACTIVITY_SUCCESS: 'TEACHER_ACTIVITY/DELETE_ACTIVITY_SUCCESS',
  DELETE_ACTIVITY_FAILURE: 'TEACHER_ACTIVITY/DELETE_ACTIVITY_FAILURE',
}
